import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-invitation2",
  templateUrl: "./invitation2.component.html",
  styleUrls: ["./invitation2.component.scss"],
})
export class Invitation2Component {
  form = {
    firstName: "",
    mobile: "",
    nationalId: "",
    invitesCount: 0,
  };

  constructor(private dialogRef: MatDialogRef<Invitation2Component>) {}

  invite(): void {
    // handle invite logic here
  }

  close(): void {
    this.dialogRef.close();
  }
}
